import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import { useState } from "react";
import toast from "react-hot-toast";
import { useServiceDrawer } from "../features/orders/useServiceDrawer";
import { scheduleOrder } from "../features/orders/orderApi";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";
import { StyledButton } from "../ui/StyledButton";
import { useSearchParams } from "react-router-dom";

import { useMessageDialog } from "../../context/MessageDialogContext";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  p: 4,
  minHeight: "300px",
  borderRadius: "6px",
};

const OrderScheduleModal = () => {
  const [date, setDate] = useState<string>("");
  const [searchParams, setSearchParams] = useSearchParams();

  const { showMessage } = useMessageDialog();

  const { isScheduleOrderOpen, setSyncOrder, id, onCloseSchedule } =
    useServiceDrawer();

  const addOrderScheduleHandler = () => {
    scheduleOrder([
      {
        id: id
          ? parseInt(id as string)
          : parseInt(searchParams.get("orderId") as string),
        pickup_date: formatDate(new Date(date)),
      },
    ])
      .then((data) => {
        if (data?.data?.data[0].error === false) {
          showMessage("Success","Order Scheduled successfully!");
          onCloseSchedule();
          setSyncOrder();
        } else {
          showMessage("Error",data?.data?.data?.[0]?.message);
        }

        searchParams.delete("orderId");
        setSearchParams(searchParams);
      })
      .catch((err) => console.log(err));
  };

  const handleDayjs = (data: Dayjs | null) => {
    setDate(data?.toDate().toISOString() as string);
  };

  const formatDate = (currentDate: Date) => {
    const formattedDate = `${currentDate.getFullYear()}-${String(
      currentDate.getMonth() + 1
    ).padStart(2, "0")}-${String(currentDate.getDate()).padStart(
      2,
      "0"
    )} ${String(currentDate.getHours()).padStart(2, "0")}:${String(
      currentDate.getMinutes()
    ).padStart(2, "0")}:${String(currentDate.getSeconds()).padStart(2, "0")}`;
    return formattedDate;
  };

  const doItLaterHandler = () => {
    setSyncOrder();
    onCloseSchedule();
  };

  return (
    <Modal open={isScheduleOrderOpen} onClose={() => onCloseSchedule("")}>
      <Box sx={style}>
        <Stack
          justifyContent={"space-between"}
          direction={"column"}
          sx={{
            minHeight: "240px",
          }}
        >
          <div>
            <Typography variant="h6" component="h2" marginBottom={"20px"}>
              Schedule Pickup Your Order
            </Typography>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker
                sx={{
                  width: "100%",
                }}
                onChange={handleDayjs}
              />
            </LocalizationProvider>
          </div>

          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"8px"}
          >
            <StyledButton
              fullWidth
              onClick={doItLaterHandler}
              variant="outlined"
            >
              Do it Later
            </StyledButton>
            <StyledButton onClick={addOrderScheduleHandler} variant="contained">
              Schedule
            </StyledButton>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};

export default OrderScheduleModal;
